import { css } from '@emotion/react';
import theme from '../../styles/theme';
import { sliderColors } from './constants';
export const colorStyles = {
    [sliderColors.dark]: css `
    background-color: ${theme.colors.gray700};
  `,
    [sliderColors.green]: css `
    background-color: '#91ac4c';
  `,
};
export const fillColorStyles = {
    [sliderColors.dark]: css `
    background-color: ${theme.colors.gray700};
  `,
    [sliderColors.green]: css `
    background-color: #e2eace;
  `,
};
